(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.filter('RfGlobalDateFilter', [RfGlobalDateFilterFn]);

    // date filter (day, month, year), uses moment.locale (set on login)
    function RfGlobalDateFilterFn() {
        return function (date) {
            if (date) {
                return moment(date).format('L');
            }
            return date;
        };
    }
})();